import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_CATEGARY, GET_CATEGARY_BY_ID } from "../constants";

export const getCategory = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("category/get_all", data);
    if (response?.data?.status) {
      dispatch({
        type: GET_CATEGARY,
        categorylist: response?.data?.response || [],
      });
    } else {
      dispatch({ type: GET_CATEGARY, categorylist: [] });
    }
  } catch (err) {
    console.error(err);
    dispatch({ type: GET_CATEGARY, categorylist: [] });
  }
};

export const addCategory = (data, setLoading, navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("category/create", data);
    if (response?.data?.status) {
      navigate("/category");
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      return response;
    }

  else{
    swal({
      text: response?.data?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const updateCategory = (data, setLoading,navigate) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("category/update", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      navigate("/category")

      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const deleteCategory = (id, setLoading, params) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`category/delete/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message,
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      dispatch(getCategory(params));
      return response;
    }
else{
  swal({
    text: response?.data?.message,
    icon: "error",
    button: "Close",
    timer: 1500,
  });
}
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const getCategoryById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`category/get_byid/${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_CATEGARY_BY_ID,
        categorybyid: response.data.response,
      });
      return response;
    }
    swal({
      text: response?.data?.response?.message,
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } catch (err) {
    console.error(err);
  } finally {
  }
};
